import LabServiceModel from "@/models/LabServiceModel";
import SampleModel from "./SampleModel";
import SampleStatusModel from "./SampleStatusModel";

export default class SampleStatusLogModel extends LabServiceModel {
  modelName() {
    return 'sample-status-log';
  }
  defaults() {
    return {
      id: null,
      sample_id: null,
      sample: null,
      sample_status_id: null,
      sample_status: null,
      start_date: null,
      end_date: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      sample_id: (val) => (this.nullStringMutator(val)),
      sample_status_id: (val) => (this.nullStringMutator(val)),
      start_date: (val) => (this.nullStringMutator(val)),
      end_date: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }
  routes() {
    const baseRoute = `${process.env.VUE_APP_LAB_REPOSITORY_URL}/api/v1/`;
    const routes = super.routes();

    routes.batchReceive = `${baseRoute}${this.modelName()}/batch`;

    return routes;
  }
  batchReceive(batch) {
    const config = {
      method: this.getMethod("save"),
      url: this.getURL(this.getRoute("batchReceive")),
      data: {
        ...batch
      },
    };

    return this.createRequest(config).send();
  }
  validation() {
    return {}
  }
  getSample() {
    return this.getRelatedModel(SampleModel, 'sample');
  }
  getSampleStatus() {
    return this.getRelatedModel(SampleStatusModel, 'sample_status');
  }
  getStatus() {
    return this.getSampleStatus();
  }

}
